<template>
   <swiper
    id="swiper"
    :allowTouchMove="false"
    :direction="'vertical'"
    :slidesPerView="1"
    :spaceBetween="0"
    :shortSwipes="false"
    :longSwipesRatio="0.1"
    :longSwipesMs="100"
    @setTranslate="initSwipe"
    @activeIndexChange="activeIndexChange"
    @afterInit="afterInit"
    :pagination="{
      clickable: true,
    }"
    :modules="modules"
    class="mySwiper"
  >
    <swiper-slide>
      <designfoodslide1-vue ref="designfood1" :design="design1" style="width:100%;height:100%;"></designfoodslide1-vue>
    </swiper-slide>
    <swiper-slide>
      <designfoodslide2-vue ref="designfood2" :design="design2" style="width:100%;height:100%;"></designfoodslide2-vue>
    </swiper-slide>
    <swiper-slide>
      <designfoodslide3-vue ref="designfood3" style="width:100%;height:100%;"></designfoodslide3-vue>
    </swiper-slide>
    <swiper-slide>
      <designfoodslide4-vue ref="designfood4" :design="design3" style="width:100%;height:100%;"></designfoodslide4-vue>
    </swiper-slide>
    <swiper-slide>
      <designfoodslide5-vue ref="designfood5" style="width:100%;height:100%;"></designfoodslide5-vue>
    </swiper-slide>
    <swiper-slide>
      <designfoodslide6-vue id="designfoodslide6" style="width:100%;padding-top: 90px;"></designfoodslide6-vue>
    </swiper-slide>
  </swiper>
</template>

<script>
import {ref, onMounted } from "vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import designfoodslide1Vue from "../components/designfood/designfoodslide1.vue";
import designfoodslide2Vue from "../components/designfood/designfoodslide2.vue";
import designfoodslide3Vue from "../components/designfood/designfoodslide3.vue";
import designfoodslide4Vue from "../components/designfood/designfoodslide4.vue";
import designfoodslide5Vue from "../components/designfood/designfoodslide5.vue";
import designfoodslide6Vue from "../components/designfood/designfoodslide6.vue";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination, Scrollbar, Virtual } from "swiper";

import { textList, commentList } from "../api/index";

export default {
  name: 'App',
  components: {
    Swiper,
    SwiperSlide,
    designfoodslide1Vue,
    designfoodslide2Vue,
    designfoodslide3Vue,
    designfoodslide4Vue,
    designfoodslide5Vue,
    designfoodslide6Vue
  },
  setup() {

    const swiperRef = ref(null);
    const swiperBool = ref(true);
    const swiperPosition = ref(0);  //0 是初始化， 1是向上，deltaY为-   2是向下， deltaY为+
    const swiperDistance = ref(0);
    
    const wheelControl = (event) => {
      if (swiperBool.value == false) return
        event = event || window.event;
        let a = document.getElementById('swiper')
        let less = a.clientHeight - window.innerHeight
        let scrollTop = document.documentElement.scrollTop
        if (swiperPosition.value == 0) {
          if (less - scrollTop <= 2 && event.wheelDelta < 0 && Math.abs(event.deltaY) > 50) {
            swiperDistance.value = 0;
            if (swiperRef.value.activeIndex != 5) {
              swiperPosition.value = 1;
              if (window.innerHeight > 878) {
                wheelControl(event)
                return
              }
              swiperBool.value = false;
              setTimeout(() => {
                swiperBool.value = true
              }, 500);
            }
          } else if (scrollTop <= 2 && event.wheelDelta > 0 && Math.abs(event.deltaY) > 50) {
            swiperDistance.value = 0;
            if (swiperRef.value.activeIndex != 0) swiperPosition.value = 2;
          }
        } else if (swiperPosition.value == 1) {
          if (event.wheelDelta > 0 && Math.abs(event.deltaY) > 50) {
            swiperPosition.value = 0
          } else {
            swiperDistance.value = swiperDistance.value + Math.abs(event.deltaY)
            if (swiperDistance.value > 0) {
              swiperBool.value = false
              swiperRef.value.slideTo(swiperRef.value.activeIndex + 1, 800, false)
              if (swiperRef.value.activeIndex < 5) {
                setTimeout(() => {
                  document.documentElement.scrollTop = 0
                }, 800);
              }
              setTimeout(() => {
                  swiperBool.value = true
                  swiperPosition.value = 0
                }, 800);
            }
          }
        } else if (swiperPosition.value == 2) {
          swiperDistance.value = swiperDistance.value + Math.abs(event.deltaY)
            if (swiperDistance.value > 0) {
              swiperBool.value = false
              swiperRef.value.slideTo(swiperRef.value.activeIndex - 1, 800, true)
              setTimeout(() => {
                swiperBool.value = true
                swiperPosition.value = 0
              }, 800);
            }
        }
    };
    const mainObj = ref({})
    const goodsObj = ref({})
    onMounted(() => {
    
      document.documentElement.scrollTop = 0
      document.body.onmousewheel = wheelControl;
      document.body.addEventListener("DOMMouseScroll", wheelControl);
      getMessage()
    });

    const design1 = ref(null)
    const design2 = ref(null)
    const design3 = ref(null)

    const getMessage = () => {
      textList({page: 1, size: 100000, status: '1'}).then((res) => {
        if (res.errCode === 200) {
          for (let i = 0; i < res.data.length; i++) {
            let temp =res.data[i]
            if (temp.type == "Banner" && !design1.value) {
              design1.value = temp
            } else if (temp.type == "List" && !design2.value) {
              design2.value = temp
            }
            if (design1.value && design2.value) break
          }
        }
      });
      commentList({page: 1, size: 100000}).then((res) => {
        if (res.errCode === 200) {
          design3.value = res.data
        }
      }); 
    };

    let designfood1 = ref(null)
    let designfood2 = ref(null)
    let designfood3 = ref(null)
    let designfood4 = ref(null)
    let designfood5 = ref(null)
    const beforeSelected = ref(0)

    const afterInit = (swiper) =>{
      swiperRef.value = swiper
      designfood1.value.changeAnime()
      beforeSelected.value = 0
    };

    const activeIndexChange = (swiper) =>{
      if (swiper.activeIndex == 0) {
        designfood1.value.changeAnime()
        beforeSelected.value = 0
      }else if (swiper.activeIndex == 1) {
        designfood2.value.changeAnime()
        beforeSelected.value = 1
      } else if (swiper.activeIndex == 2) {
        designfood3.value.changeAnime()
        beforeSelected.value = 2
      }else if (swiper.activeIndex == 3) {
        designfood4.value.changeAnime()
        beforeSelected.value = 3
      } else if (swiper.activeIndex == 4) {
        let show = beforeSelected.value != 5 ? false : true
        designfood5.value.changeAnime(show)
        beforeSelected.value = 4
      } else {
        beforeSelected.value = 5
      }
    };
    const initSwipe = (swiper) =>{
      let screen = document.getElementById('designfoodslide6')
      let screenHeight = document.documentElement.scrollHeight || document.body.scrollHeight
      let weight = (screenHeight * -4) - screen.clientHeight
      if (swiper.translate < weight) {
        swiper.setTranslate(weight);
      }
    }
    return {
      mainObj,
      goodsObj,
      beforeSelected,
      swiperPosition,
      swiperDistance,
      swiperBool,
      swiperRef,
      activeIndexChange,
      afterInit,
      initSwipe,
      designfood1,
      designfood2,
      designfood3,
      designfood4,
      designfood5,
      design1,
      design2,
      design3,
      modules: [Pagination, Scrollbar, Virtual],
    };
  },
}
</script>

<style scoped>
.swiper {
  width: 100%;
  height: 100%;
}
:deep(.swiper-pagination){
  display: none;
    margin-right: 50px;
}

</style>
